var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3496,
    cy: 12.0186,
    r: 11.75,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3753 8.16675H7.62533C7.02702 8.16675 6.54199 8.65177 6.54199 9.25008V15.7501C6.54199 16.3484 7.02702 16.8334 7.62533 16.8334H17.3753C17.9736 16.8334 18.4587 16.3484 18.4587 15.7501V9.25008C18.4587 8.65177 17.9736 8.16675 17.3753 8.16675Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54199 11.4167H18.4587",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 14.542H8.27084C8.12134 14.542 8 14.6633 8 14.8128C8 14.9623 8.12134 15.0837 8.27084 15.0837H12.0625C12.212 15.0837 12.3333 14.9623 12.3333 14.8128C12.3333 14.6633 12.212 14.542 12.0625 14.542Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 13H8.27084C8.12134 13 8 13.1213 8 13.2708C8 13.4203 8.12134 13.5417 8.27084 13.5417H10.4375C10.587 13.5417 10.7083 13.4203 10.7083 13.2708C10.7083 13.1213 10.587 13 10.4375 13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpi);
export default __webpack_public_path__ + "static/media/upi.cfe850ce2df40bf581400909a70a9038.svg";
export { ForwardRef as ReactComponent };